const img = require('./pause.png'); export default img;